import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';

import { SuburbColourPickerComponent } from '../panel/suburb-colour-picker.component';
import { RegionSubRegionsComponent } from './region-subregions.component';

/**
 * The part of the Suburbs tool that Website → Regions draws in its own window (#280): a region's sub-regions and the
 * colour picker they share with the tool's sub-region panel. Its own small module so ContentModule can import it
 * eagerly while SuburbsModule (the tool itself) loads on demand (ModalService.listSuburbs).
 */
@NgModule({
  declarations: [RegionSubRegionsComponent, SuburbColourPickerComponent],
  imports: [CommonModule, ButtonModule, TooltipModule],
  exports: [RegionSubRegionsComponent, SuburbColourPickerComponent],
})
export class SuburbRegionsModule {}
